<template>
  <div id="main-content">
    <a-collapse default-active-key="cash" :bordered="true" :accordion="true">
      <template #expandIcon="props">
        <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
      </template>
      <a-collapse-panel v-for="data_info in dataInfoList"
                        :key="data_info.id"
                        :header="data_info.name" :style="data_info.style">
        <div v-html="data_info.content"></div>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
export default {
  name: "DataInfoNotice",
  data(){
    return {
      dataInfoList:[
        {
          id:'cash',
          name:'收益 -- 规则',
          content:'',
          style:{}
        },
        {
          id:'spend',
          name:'花费 -- 规则',
          content:'',
          style:{}
        },
        {
          id:'purchase',
          name:'内购 -- 规则',
          content:'',
          style:{}
        },
        {
          id:'exchange_rate',
          name:'汇率 -- 规则',
          content:'',
          style:{}
        }
      ]
    }
  },
  mounted() {
    this.dataInfoList[0].content += "<p>支持渠道："
    this.$store.state.RevenueChannel.forEach(item=>{
      this.dataInfoList[0].content += item.name+"、"
    })
    this.dataInfoList[0].content += "</p>"
    this.dataInfoList[0].content +="<p>固定拉取：每天 8:30 、17:20、20:30</p>"
    this.dataInfoList[0].content +="<p>回滚拉取：每天 7：30"
    this.dataInfoList[0].content += "<br> facebook：2天后、5天后"
    this.dataInfoList[0].content += "<br> google：2天后、5天后</p>"
    this.dataInfoList[0].content +="<p>计算规则："
    Object.keys(this.$store.state.RevenueChange).forEach(channel_item => {
      this.dataInfoList[0].content +="<br>"+channel_item+"："+this.$store.state.RevenueChange[channel_item]
    })
    this.dataInfoList[0].content +="</p>"
    this.dataInfoList[1].content += "<p>支持渠道："
    this.$store.state.SpendChannel.forEach(item=>{
      this.dataInfoList[1].content += item.name+"、"
    })
    this.dataInfoList[1].content += "</p>"
    this.dataInfoList[1].content +="<p>固定拉取：每天 8:30 、16:30、20:30</p>"
    this.dataInfoList[1].content +="<p>回滚拉取：每天 7：30"
    this.dataInfoList[1].content += "<br> facebook：3天后、7天后"
    this.dataInfoList[1].content += "<br> google：3天后、7天后"
    this.dataInfoList[1].content += "<br> tiktok：3天后、7天后"
    this.dataInfoList[1].content += "</p>"
    this.dataInfoList[1].content +="<p>计算规则：</p>"
    this.dataInfoList[1].content +="<p>ASM：5%手续费</p>"
    this.dataInfoList[2].content +="<p>Google拉取：每天 9:05 、16:05、20:05 更新一天前</p>"
    this.dataInfoList[2].content +="<p>Apple拉取：每天 14:30 更新两天前</p>"
    this.dataInfoList[2].content +="<p>Google计算：" +
      "交易货币 按 日汇率 转 账户货币，" +
      "账户货币 按 月汇率 转 美金；</br>" +
      "GST扣除：甜点账户 扣7%；2023-05-01以后 扣8%；2024-01-01以后 扣9%；</br>" +
      "WHT扣除：TW地区 扣3%,BR地区 扣25%（2025-11-01起：Android针对BR地区，WHT分成从分成后金额变成了分成前金额，比例25%不变）</p>"
    this.dataInfoList[2].content +="<p>Apple计算：" +
      "交易货币 按 每月1日汇率 转 账户货币，" +
      "账户货币 按 月汇率 转 美金；</br>" +
      "税点扣除：APPLE香港（mobibrain.tec@outlook.com ）账户有扣除," +
      "普通地区：扣 1.25%，TW地区：扣 1.5%，TR地区：扣 1.9%</br>" +
      "2023-04-01起：APPLE香港（mobibrain.tec@outlook.com ）账户有扣除," +
      "普通地区：扣 1.41%，TW地区：扣 1.5%，TR地区：扣 1.9%，VN地区：扣 2.5%</br>" +
      "2024-05-01起：APPLE香港（mobibrain.tec@outlook.com ）账户有扣除," +
      "普通地区：扣 4%，TW地区：扣 4.3%，JP、KR地区：扣 3.9%</br>" +
      "系数修正：默认乘：98%；可按账户按月份修改修正系数</br>" +
      "2025年10月1日起,主平台收支结算内购收入iOS部分乘以0.98,和内购中心数据保持一致,Google保持不变</p>"
    this.dataInfoList[3].content +="<p>日 汇率：每天 8:30 更新当日汇率</p>"
    this.dataInfoList[3].content +="<p>月 汇率：每天 12:05 更新下月汇率，1号更新当月汇率</p>"
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Home/DataInfoNotice.vue